<div class="menu-list-new menu-list-new--context js-component-content">
    @for (item of collection; track item) {
        <div
            class="menu-list-new__item"
            (click)="onItemSelect(item)"
            (pointerenter)="onPointerEnter(item, $event)">
            @if (item.submenu) {
                <skl-menu-item-sub
                    class="display--contents display-edge--contents-flex"
                    [context]="context"
                    [item]="item"
                    (close)="close()">
                </skl-menu-item-sub>
            } @else {
                <skl-menu-item
                    class="display--contents display-edge--contents-flex"
                    [context]="context"
                    [item]="item">
                </skl-menu-item>
            }
        </div>
    }
</div>
